import React from 'react'
import GenericError from './GenericError'
import PasswordlessLinkExpiredError from './PasswordlessLinkExpiredError'
import PasswordlessLinkUsedError from './PasswordlessLinkUsedError'
import ResetPasswordLinkExpiredError from './ResetPasswordLinkExpiredError'
import ResetPasswordLinkUsedError from './ResetPasswordLinkUsedError'
import styles from './Error.scss'
import {
  passwordlessLinkExpiredError,
  passwordlessLinkUsedError,
  resetPasswordLinkExpiredError,
  resetPasswordLinkUsedError,
} from '../../utils/errors/constants'

type ErrorComponentProps = {
  body: string
  code: string
  ctaText: string
}

function ErrorComponent({ body, code, ctaText }: ErrorComponentProps) {
  if (code === passwordlessLinkExpiredError.code)
    return <PasswordlessLinkExpiredError code={code} />
  if (code === passwordlessLinkUsedError.code) return <PasswordlessLinkUsedError code={code} />
  if (code === resetPasswordLinkExpiredError.code)
    return <ResetPasswordLinkExpiredError code={code} />
  if (code === resetPasswordLinkUsedError.code) return <ResetPasswordLinkUsedError code={code} />
  return <GenericError body={body} ctaText={ctaText} />
}

type Props = {
  body?: string
  code?: string
  ctaText?: string
  title?: string
}

export default function Error({
  body = "We've had a technical problem, please try again later.",
  code = 'callback.error',
  ctaText = 'Back to previous page',
  title = 'Sorry, something went wrong',
}: Props) {
  return (
    <div data-testid="error" className={styles.container}>
      <h1 data-testid="error-title" className={styles.headerText}>
        {title}
      </h1>
      <ErrorComponent body={body} code={code} ctaText={ctaText} />
    </div>
  )
}
